import { render } from "./EditFileButton.vue?vue&type=template&id=648f6744&ts=true"
import script from "./EditFileButton.vue?vue&type=script&lang=ts"
export * from "./EditFileButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__